import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './_guards/auth.guard';
import { HomeComponent } from './component/home/home.component';
import { PlatformComponent } from './component/platform/platform/platform.component';
import { ProfiloComponent } from './component/profilo/profilo/profilo.component';
import { RestorePasswordComponent } from './component/restore-password/restore-password/restore-password.component';
import { CourseComponent } from './component/course/course/course.component';
import { EsercitazioneComponent } from './component/esercitazione/esercitazione/esercitazione.component';
import { EsercitazioniArchivioComponent } from './component/esercitazione/esercitazioni-archivio/esercitazioni-archivio.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { ModuloComponent } from './component/course/modulo/modulo/modulo.component';
import { EsercitazioniCorsoComponent } from './component/esercitazione/esercitazioni-corso/esercitazioni-corso.component';
import { EsercitazioniModuloComponent } from './component/esercitazione/esercitazioni-modulo/esercitazioni-modulo.component';
import { CorsoModuloMainComponent } from './component/course/corso-modulo-main/corso-modulo-main.component';
import { FirstChangePasswordComponent } from './component/change-password/first-change-password/first-change-password.component';
import { DefaultChangePasswordComponent } from './component/change-password/default-change-password/default-change-password.component';
import { LezioneComponent } from './component/course/lezione/lezione.component';

const routes: Routes = [
  { path: 'corso/lezione/:courseId/:moduleId', component: LezioneComponent, canActivate: [AuthGuard] },
  { path: 'cambio-password', component: FirstChangePasswordComponent, canActivate: [AuthGuard] },
  { path: 'p', component: PlatformComponent, canActivate: [AuthGuard],
      children: [
        { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        { path: 'cambio-password', component: DefaultChangePasswordComponent, canActivate: [AuthGuard] },
        { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
        { path: 'profilo', component: ProfiloComponent, canActivate: [AuthGuard] },
        { path: 'corso', component: CorsoModuloMainComponent, canActivate: [AuthGuard], children: [
          { path: '', redirectTo: '/p/dashboard', pathMatch: 'full' },
          { path: ':courseId', component: CourseComponent, canActivate: [AuthGuard] },
          { path: 'modulo/:courseId/:moduloId', component: ModuloComponent, canActivate: [AuthGuard] },
        ] },
        { path: 'esercitazioni/esercitazione/:courseId/:moduleId', component: EsercitazioneComponent, canActivate: [AuthGuard] },
        { path: 'esercitazioni/esercitazione/:courseId/:moduleId/:esercitazioneId', component: EsercitazioneComponent, canActivate: [AuthGuard] },
        { path: 'esercitazioni/archivio/:courseId/:moduloId', component: EsercitazioniArchivioComponent, canActivate: [AuthGuard] },
        { path: 'esercitazioni/:courseId', component: EsercitazioniCorsoComponent, canActivate: [AuthGuard] },
        { path: 'esercitazioni/:courseId/:moduloId', component: EsercitazioniModuloComponent, canActivate: [AuthGuard] },
      ]
  },
  { path: 'recupero-password', component: RestorePasswordComponent },
  { path: '', component: HomeComponent },
  { path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
